export default function checkAccess(user,permission){console.info("[checkAccess] stub",{user,permission});return Boolean(user && permission);}
